/**
 * Monitors and returns the total scroll height for a ref
 */
export function useRefScrollHeight(ref: React.RefObject<HTMLElement>) {

    const [dimensions, setDimensions] = React.useState<{ height: number } | undefined>(() => ref.current
        ? { height: getMaxScrollHeight(ref.current) }
        : undefined
    )

    React.useEffect(() => {

        const e = ref.current

        if (e) {

            const observer = new MutationObserver(list => {
                if (list.some(e => e.type === "childList")) {
                    const height = getMaxScrollHeight(e)
                    setDimensions({ height })
                }
            })

            observer.observe(e, { childList: true, subtree: true })

            return () => observer.disconnect()

        }

    }, [ref])

    return dimensions
}


/**
 * Returns the total scroll height for an element, taking all its
 * descendants into account
 */
function getMaxScrollHeight(node: Element) {

    let scrollHeight = 0

    for (let i = 0; i < node.children.length; i++) {
        scrollHeight += getMaxScrollHeight(node.children[i])
    }

    return Math.max(scrollHeight, node.scrollHeight)

}
